import React from 'react';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { isExternalLink, mergeClassNames } from '@core/shared';
import classes from './CallToAction.module.scss';
import { IconExternalLink } from '@tabler/icons-react';
import { renderMarkdownToReact } from '@core/frontend/ui';
import CustomStyledText from '../CustomStyledText/CustomStyledText.jsx';

const callToAction = (props) => {
    let ctaLink = null;
    const copy = props.copy || null;

    // Todo: Refactor buttonText Prop to linkText because text links for external sites have been added
    if (props.buttonVisibility && props.linkUrl && props.buttonText) {
        if (isExternalLink(props.linkUrl)) {
            ctaLink = (
                <CustomStyledText
                    tag={Button}
                    styleConfig={props.buttonStyleConfig}
                    outline={props.outline}
                    className={mergeClassNames(
                        'mt-auto',
                        'btn-block',
                        'btn-md-inline-block',
                        props.btnClass,
                        props.buttonClassName
                    )}
                    color={props.buttonColor || 'secondary'}
                    style={{ ...props.buttonStyle, ...props.style }}
                    href={props.linkUrl + '/'}
                    target="_blank"
                    rel="external noopener"
                >
                    {props.buttonText}
                    <IconExternalLink size={24} className="ms-1" />
                </CustomStyledText>
            );
        } else {
            ctaLink = (
                <CustomStyledText
                    tag={Button}
                    innerTag={Link}
                    styleConfig={props.buttonStyleConfig}
                    outline={props.outline}
                    className={mergeClassNames(
                        'mt-auto',
                        'btn-block',
                        'btn-md-inline-block',
                        props.btnClass,
                        props.buttonClassName
                    )}
                    color={props.buttonColor || 'secondary'}
                    style={{ ...props.buttonStyle, ...props.style }}
                    to={props.linkUrl + '/'}
                >
                    {props.buttonText}
                </CustomStyledText>
            );
        }
    }

    return (
        <>
            <CustomStyledText
                tag="h2"
                styleConfig={props.headlineStyleConfig}
                className={mergeClassNames(props.bootstrapClass, props.headlineClassName)}
                style={props.headlineStyle}
            >
                {props.headline}
            </CustomStyledText>
            {copy && (
                <CustomStyledText
                    tag="p"
                    styleConfig={props.copyStyleConfig}
                    className={mergeClassNames(classes.CallToAction, props.bootstrapClass, props.copyClassName)}
                    style={props.copyStyle}
                >
                    {renderMarkdownToReact(copy)}
                </CustomStyledText>
            )}
            {ctaLink}
        </>
    );
};

export default callToAction;
